import React from 'react'
import PropTypes from 'prop-types'
import { Chip } from 'material-ui'
import styles from './chip-styles'
import './chip-styles.css'

const CancelableChip = ({
  description,
  handleRemoveChip,
  id,
  title,
  type,
}) => (
  <Chip
    onRequestDelete={() => handleRemoveChip(id, type)} // the 'type' param doesn't need to be passed a value, extra args won't do anything
    style={styles.chip}
  >
    <div className="chip">
      {title && <span className="chipTitle">{title}</span>}
      {description && <span className="chipBody">{description}</span>}
    </div>
  </Chip>
)

CancelableChip.propTypes = {
  id: PropTypes.string.isRequired,
  description: PropTypes.string,
  handleRemoveChip: PropTypes.func.isRequired,
  title: PropTypes.string,
  type: PropTypes.string,
}

export default CancelableChip



// WEBPACK FOOTER //
// ./src/components/sitewide/Chips/CancelableChip.js